import React from 'react';
import './EquipmentRent.css'; 
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons'; 
import Footer from './footer';

const EquipmentRent = () => {
  return (
    <>
      <section className="eqp equipment-page py-16">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl font-bold text-dark-blue mb-8">Available Medical Equipment for Rent</h1>
          <p className="text-base leading-relaxed text-gray-700 mb-12">
            We provide a wide range of high-quality medical equipment available for rental. From wheelchairs to hospital beds, we have the equipment to meet your healthcare needs.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
            <div className="equipment-item">
              <img src="/DBLOODPM.jpg" alt="Digital Blood Pressure Monitor" className="w-full rounded-lg shadow-md mb-4 hover-glow" />
              <h3 className="text-xl font-semibold text-dark-blue mb-2">Digital Blood Pressure Monitor</h3>
              <p className="text-sm text-gray-700 leading-relaxed">
                Our easy-to-use digital blood pressure monitors allow patients to conveniently track their blood pressure levels at home with accurate readings.
              </p>
            </div>

            <div className="equipment-item">
              <img src={process.env.PUBLIC_URL + "/ultrasonic.jpg"} alt="Ultrasonic Height and Weight Measurement Scale" className="w-full rounded-lg shadow-md mb-4 hover-glow" />
              <h3 className="text-xl font-semibold text-dark-blue mb-2">Ultrasonic Height and Weight Measurement Scale</h3>
              <p className="text-sm text-gray-700 leading-relaxed">
                This advanced scale uses ultrasonic technology to quickly and accurately measure both height and weight, providing critical data for health assessments.
              </p>
            </div>

            <div className="equipment-item">
              <img src="/DWS.jpg" alt="Digital Weighing Scale" className="w-full rounded-lg shadow-md mb-4 hover-glow" />
              <h3 className="text-xl font-semibold text-dark-blue mb-2">Digital Weighing Scale</h3>
              <p className="text-sm text-gray-700 leading-relaxed">
                With precise weight measurement, our digital weighing scale is ideal for monitoring body weight. It’s sleek, reliable, and easy to use.
              </p>
            </div>

            <div className="equipment-item">
              <img src="/GLUCOSE.jpg" alt="Blood Glucose Monitoring System" className="w-full rounded-lg shadow-md mb-4 hover-glow" />
              <h3 className="text-xl font-semibold text-dark-blue mb-2">Blood Glucose Monitoring System</h3>
              <p className="text-sm text-gray-700 leading-relaxed">
                Designed for patients with diabetes, our blood glucose monitoring system provides fast, accurate readings to help manage blood sugar levels.
              </p>
            </div>

            <div className="equipment-item">
              <img src="/ECG.jpg" alt="ECG Monitor" className="w-full rounded-lg shadow-md mb-4 hover-glow" />
              <h3 className="text-xl font-semibold text-dark-blue mb-2">ECG Monitor</h3>
              <p className="text-sm text-gray-700 leading-relaxed">
                Our portable ECG monitors are vital for capturing real-time heart activity, allowing early detection of any irregularities.
              </p>
            </div>

            <div className="equipment-item">
              <img src="/SPIROMETRE.jpg" alt="Spirometer" className="w-full rounded-lg shadow-md mb-4 hover-glow" />
              <h3 className="text-xl font-semibold text-dark-blue mb-2">Spirometer</h3>
              <p className="text-sm text-gray-700 leading-relaxed">
                This spirometer provides accurate lung function tests, helping to diagnose and monitor respiratory conditions such as asthma.
              </p>
            </div>

            <div className="equipment-item">
              <img src="/ECGPAPER.jpg" alt="ECG Machine with Paper Printout" className="w-full rounded-lg shadow-md mb-4 hover-glow" />
              <h3 className="text-xl font-semibold text-dark-blue mb-2">ECG Machine with Paper Printout</h3>
              <p className="text-sm text-gray-700 leading-relaxed">
                This ECG machine provides clear, printed records of heart rhythms, offering healthcare professionals a reliable way to track cardiac activity.
              </p>
            </div>

            <div className="equipment-item">
              <img src="/TONOMETRY.jpg" alt="Portable Tonometry Device" className="w-full rounded-lg shadow-md mb-4 hover-glow" />
              <h3 className="text-xl font-semibold text-dark-blue mb-2">Portable Tonometry Device</h3>
              <p className="text-sm text-gray-700 leading-relaxed">
                Our portable tonometry device offers a convenient and non-invasive way to measure intraocular pressure, essential for diagnosing glaucoma.
              </p>
            </div>
          </div>

          <div className="rental-terms mt-12">
            <h3 className="text-2xl font-semibold text-dark-blue mb-4">Rental Terms</h3>
            <p className="text-base text-gray-700 leading-relaxed max-w-3xl mx-auto">
              Our equipment is available on an hourly or daily basis, with flexible rental plans to suit your needs.
            </p>

            <div className="mt-8">
              <a
                href="https://wa.me/919910967118?text=Hello%2C%20I%20am%20interested%20in%20renting%20medical%20equipment%20from%20Guardians%20Home%20Care."
                className="button-cta"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon icon={faWhatsapp} className="mr-2" /> Rent Now
              </a>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default EquipmentRent;
